module.exports = __webpack_public_path__ + "img/pattern-tree.ca5e9f3d.svg";